import { useNavigate } from "react-router-dom";

export function ImpersonationBanner() {
  const navigate = useNavigate();
  const impersonating = sessionStorage.getItem("impersonating_org");
  if (!impersonating) return null;

  const handleExit = () => {
    sessionStorage.removeItem("impersonating_org");
    sessionStorage.removeItem("impersonation_token");
    // Restore original cookie-based session — just reload to /admin
    navigate("/admin");
    window.location.reload();
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between bg-amber-500 px-4 py-2 text-sm font-medium text-white">
      <span>
        Impersonating org: <strong>{impersonating}</strong>
      </span>
      <button
        onClick={handleExit}
        className="rounded bg-white/20 px-3 py-1 text-xs hover:bg-white/30"
      >
        Exit Impersonation
      </button>
    </div>
  );
}
